import React from "react";
import { HomeViewWrapper, PlanCardsWrapper } from "./styles";
import { ListGroup, Button, Spinner, Row, Col, Card, Modal, Form, Alert } from "react-bootstrap";
import { savePreference, getPlanes } from "../../services/firebase/planes";
import { useSelector, useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { registrarPagoMembresia } from "../../services/firebase/empresas/index";
import { uploadFileToFolder, getUrlFile } from "../../services/firebase/storage/index";
import { setEmpresa } from "../../redux/empresa/empresaActions";
export const BOLSAS_SOLO_MENSAJES = [
  {
    id: "bolsa-10",
    nombre: "Bolsa 20 Mensajes",
    monto: 10,
    mensajesWhatsapp: 20,
    badge: "Básico",
    badgeBg: "#67D2DC",
    popular: false,
    descripcion: "20 créditos de mensajes por WhatsApp sin alterar la fecha ni estado de tu suscripción actual.",
  },
  {
    id: "bolsa-15",
    nombre: "Bolsa 35 Mensajes",
    monto: 15,
    mensajesWhatsapp: 35,
    badge: "Recomendado",
    badgeBg: "#0c8de3",
    popular: false,
    descripcion: "35 créditos de mensajes por WhatsApp adicionales con mejor rendimiento.",
  },
  {
    id: "bolsa-20",
    nombre: "Bolsa 50 Mensajes",
    monto: 20,
    mensajesWhatsapp: 50,
    badge: "Más Popular ⭐",
    badgeBg: "#8b5cf6",
    popular: true,
    descripcion: "50 créditos de mensajes por WhatsApp con descuento por volumen.",
  },
];

export const PAQUETES_RECARGA = [
  {
    id: "recarga-10",
    nombre: "Recarga Básica",
    monto: 10,
    diasVigencia: 15,
    mensajesWhatsapp: 20,
    limiteUsuarios: 1,
    limitePacientes: 50,
    badge: "15 Días",
    badgeBg: "#67D2DC",
    popular: false,
    descripcion: "15 días de acceso total para 1 usuario y hasta 50 pacientes + 20 mensajes WhatsApp.",
  },
  {
    id: "recarga-15",
    nombre: "Recarga Plus",
    monto: 15,
    diasVigencia: 20,
    mensajesWhatsapp: 35,
    limiteUsuarios: 1,
    limitePacientes: 50,
    badge: "20 Días",
    badgeBg: "#10b981",
    popular: false,
    descripcion: "20 días de acceso total para 1 usuario y hasta 50 pacientes + 35 mensajes WhatsApp.",
  },
  {
    id: "recarga-20",
    nombre: "Recarga Mensual",
    monto: 20,
    diasVigencia: 30,
    mensajesWhatsapp: 50,
    limiteUsuarios: 1,
    limitePacientes: 50,
    badge: "30 Días ⭐",
    badgeBg: "#0c8de3",
    popular: true,
    descripcion: "30 días de acceso total para 1 usuario y hasta 50 pacientes + 50 mensajes WhatsApp.",
  },
];

export const Planes = () => {
  const [selectedPlan, setSelectedPlan] = React.useState(null);
  const empresa = useSelector((state) => state.empresa);
  const sesion = useSelector((state) => state.sesion);
  const [planes, setPlanes] = React.useState([]);
  const [loadingPlanes, setLoadingPlanes] = React.useState(true);
  const [loadError, setLoadError] = React.useState(false);
  const currentPlanKey = (empresa.tipoMembresia || "").toLowerCase();
  const hasActiveMonthlyPlan =
    currentPlanKey &&
    currentPlanKey !== "free" &&
    currentPlanKey !== "prepago" &&
    currentPlanKey !== "trial";

  const [viewMode, setViewMode] = React.useState(
    empresa?.tipoMembresia?.toUpperCase() === 'PREPAGO' ? 'recargas' : 'planes'
  );
  const [selectedRecarga, setSelectedRecarga] = React.useState(PAQUETES_RECARGA[1]);
  const [selectedBolsa, setSelectedBolsa] = React.useState(BOLSAS_SOLO_MENSAJES[1]);
  const FORM_ID = "button-checkout";

  const [preferenceId, setPreferenceId] = React.useState();

  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [hoveredCardId, setHoveredCardId] = React.useState(null);

  // Manual payment states
  const [showModal, setShowModal] = React.useState(false);
  const [paymentDate, setPaymentDate] = React.useState(new Date().toISOString().split('T')[0]);
  const [paymentMethod, setPaymentMethod] = React.useState('Yape');
  const [paymentProof, setPaymentProof] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [plinUrlFile, setPlinUrlFile] = React.useState("");
  const [yapeUrlFile, setYapeUrlFile] = React.useState("");
  const [showQrZoom, setShowQrZoom] = React.useState(false);

  React.useEffect(() => {
    const getQrUrls = async () => {
      try {
        const plinFile = await getUrlFile('Aural/medios_pago/PLIN_QR_CODE_ALDO.jpg');
        const yapeFile = await getUrlFile('Aural/medios_pago/YAPE_QR_CODE_ALDO.jpg');
        setPlinUrlFile(plinFile);
        setYapeUrlFile(yapeFile);
      } catch (error) {
        console.error('Error fetching QR codes:', error);
      }
    };
    getQrUrls();
  }, []);

  const planOrder = ["BASIC", "PRO", "PREMIUM", "PLUS", "SILVER", "GOLD"];
  const planClassMap = {
    BASIC: "plan-card--basic",
    PRO: "plan-card--plus",
    PLUS: "plan-card--plus",
    SILVER: "plan-card--plus",
    PREMIUM: "plan-card--titanium",
    GOLD: "plan-card--titanium",
  };

  React.useEffect(() => {
    const fetchPlanesData = async () => {
      try {
        const data = await getPlanes();
        setPlanes(data || []);
      } catch (err) {
        console.error("Error loading plan data:", err);
        setLoadError(true);
      } finally {
        setLoadingPlanes(false);
      }
    };
    fetchPlanesData();
  }, []);

  React.useEffect(() => {
    if (planes.length > 0 && !selectedPlan) {
      const currentPlan = planes.find(
        (p) => p.id?.toLowerCase() === (empresa.tipoMembresia || "").toLowerCase()
      );
      if (currentPlan && currentPlan.id?.toLowerCase() !== "free") {
        setSelectedPlan(currentPlan);
      } else {
        const proPlan = planes.find((p) => p.id?.toLowerCase() === "pro");
        setSelectedPlan(proPlan || planes[0]);
      }
    }
  }, [planes, empresa.tipoMembresia]);

  const sortPlans = (planA, planB) => {
    const a = (planA.id || planA.nombre || "").toString().toUpperCase();
    const b = (planB.id || planB.nombre || "").toString().toUpperCase();
    const ai = planOrder.indexOf(a) >= 0 ? planOrder.indexOf(a) : 999;
    const bi = planOrder.indexOf(b) >= 0 ? planOrder.indexOf(b) : 999;
    return ai - bi || a.localeCompare(b);
  };

  const formatValue = (value, fallback = 0) => {
    return value !== undefined && value !== null ? value : fallback;
  };

  const getPlanDisplayName = (planItem) => {
    const name = planItem.nombre || planItem.plan || planItem.id || "";
    const key = name.toUpperCase();
    if (key === "PRO") return "Pro ⭐";
    if (key === "PREMIUM") return "Premium 💎";
    return name;
  };

  const getPlanPrice = (planItem) => {
    return Number(planItem.precio || planItem.price || 0);
  };

  const getPlanLimit = (planItem, fieldA, fieldB) => {
    return formatValue(planItem[fieldA], formatValue(planItem[fieldB], 0));
  };

  const planCards = [...planes]
    .filter((p) => p.id?.toLowerCase() !== "free" && getPlanPrice(p) > 0)
    .sort(sortPlans);

  const getPlanByIdentifier = (planName) => {
    return (
      planes.find(
        (p) =>
          p.id?.toLowerCase() === planName.toLowerCase() ||
          p.nombre?.toLowerCase() === planName.toLowerCase() ||
          p.plan?.toLowerCase() === planName.toLowerCase(),
      ) || null
    );
  };

  const getCardClass = (planItem) => {
    const key = (planItem.id || planItem.nombre || planItem.plan || "")
      .toString()
      .toUpperCase();
    return planClassMap[key] || "plan-card--basic";
  };

  const getButtonClass = (planItem) => {
    const key = (planItem.id || planItem.nombre || planItem.plan || "")
      .toString()
      .toUpperCase();
    return key === "PREMIUM" || key === "GOLD"
      ? "button--orange"
      : key === "PRO" || key === "PLUS" || key === "SILVER"
      ? "button--blue"
      : "button--green";
  };

  const getFeaturesForPlan = (plan) => {
    const list = [];
    if (!plan || !plan.id) return list;

    const planId = plan.id.toLowerCase();
    const cleanText = (t) => t.toLowerCase().trim().replace(/\s+/g, ' ');

    // Emojis mapping
    const emojiMap = {
      "citas": "📅",
      "agenda": "📅",
      "aplicación": "📱",
      "aplicacion": "📱",
      "recordatorios": "🔄",
      "soporte": "⚡",
      "reportes": "📊",
      "crm": "⚙️",
      "staff": "🧑‍⚕️",
      "bot": "🤖",
      "analítica": "📊",
      "analitica": "📊",
      "automatización": "⚙️"
    };

    const getEmoji = (featText) => {
      const clean = featText.toLowerCase();
      if (clean.includes("soporte estándar") || clean.includes("soporte estandar")) return "🧳";
      if (clean.includes("soporte prioritario") || clean.includes("soporte preferencial")) return "⚡";
      if (clean.includes("crm avanzado")) return "🔄";
      
      for (const key in emojiMap) {
        if (clean.includes(key)) return emojiMap[key];
      }
      return "✓";
    };

    if (planId === "basic") {
      list.push(`🧑‍⚕️ Hasta ${plan.limiteUsuarios || 2} usuarios (Doctor + Asistente)`);
      list.push(`👥 Hasta ${plan.limitePacientes || 300} pacientes`);
      if (Array.isArray(plan.caracteristicas)) {
        plan.caracteristicas.forEach((feat) => {
          if (cleanText(feat).includes("mensaje") || cleanText(feat).includes("whatsapp")) return;
          list.push(`${getEmoji(feat)} ${feat}`);
        });
      }
      list.splice(4, 0, `💬 200 mensajes WhatsApp incluidos`);
    } 
    else if (planId === "pro") {
      list.push(`🧑‍⚕️ Hasta ${plan.limiteUsuarios || 5} usuarios (Doctor + Especialistas)`);
      list.push(`👥 Hasta ${plan.limitePacientes || 1000} pacientes`);
      if (Array.isArray(plan.caracteristicas)) {
        plan.caracteristicas.forEach((feat) => {
          if (cleanText(feat).includes("mensaje") || cleanText(feat).includes("whatsapp")) return;
          let text = feat;
          if (cleanText(text).includes("agenda para pacientes") || cleanText(text).includes("agenda de pacientes")) {
            text = "Agenda de pacientes";
          }
          list.push(`${getEmoji(text)} ${text}`);
        });
      }
      list.splice(3, 0, "📱 Aplicación para pacientes");
      list.splice(6, 0, `💬 400 mensajes WhatsApp incluidos`);
    } 
    else if (planId === "premium") {
      list.push(`🧑‍⚕️ Usuarios y especialistas ilimitados`);
      if (Array.isArray(plan.caracteristicas)) {
        plan.caracteristicas.forEach((feat) => {
          if (cleanText(feat).includes("automatización")) return;
          if (cleanText(feat).includes("mensaje") || cleanText(feat).includes("whatsapp")) return;
          
          let text = feat;
          if (cleanText(feat) === cleanText("CRM avanzado de recordatorios y seguimientos")) {
            text = "CRM avanzado";
          }
          list.push(`${getEmoji(text)} ${text}`);
        });
      }
      list.splice(1, 0, "👥 Pacientes ilimitados");
      list.splice(5, 0, `💬 700 mensajes WhatsApp incluidos`);
    }

    return list;
  };

  const getCheckoutPlanName = (planItem) => {
    return getPlanDisplayName(planItem);
  };

  const handleClick = async (planItem) => {
    if (!planItem) {
      console.error("Plan no encontrado", planItem);
      return;
    }

    setSelectedPlan(planItem);

    try {
      const orderData = {
        quantity: 1,
        description: `PLAN ${getCheckoutPlanName(planItem)}`,
        price: getPlanPrice(planItem),
        fechaCliente: new Date(),
        empresaId: empresa.id,
        usuario: sesion.usuario.email,
        plan: planItem.id || planItem.nombre || planItem.plan,
      };
      let preferenceId = await savePreference(orderData);
      setPreferenceId(preferenceId);
    } catch (err) {
      console.log(err.message);
    }
  };

  function addCheckout() {
    const mp = new window.MercadoPago(
      "TEST-9667d745-cc7c-4ef6-b2b9-9e6ef52911e8",
      {
        locale: "es-PE",
      },
    );

    // Inicializa el checkout
    mp.checkout({
      preference: {
        id: preferenceId,
      },
      render: {
        container: `#${FORM_ID}`, // Indica el nombre de la clase donde se mostrará el botón de pago
        label: "Pagar", // Cambia el texto del botón de pago (opcional)
      },
    });
  }

  React.useEffect(() => {
    if (preferenceId) {
      // con el preferenceId en mano, inyectamos el script de mercadoPago
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://sdk.mercadopago.com/js/v2";
      script.addEventListener("load", addCheckout); // Con la carga del script se ejecuta addCheckout
      document.body.appendChild(script);
    }
  }, [preferenceId]);

  const handlePayClick = () => {
    setPaymentDate(new Date().toISOString().split('T')[0]);
    setPaymentMethod('Yape');
    setPaymentProof(null);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleFileChange = (e) => {
    setPaymentProof(e.target.files[0]);
  };

  const handleSubmitPayment = async (e) => {
    e.preventDefault();

    if (!paymentProof) {
      addToast("Por favor, adjunta un comprobante de pago.", { appearance: "error" });
      return;
    }

    setIsSubmitting(true);
    try {
      const paymentProofUrl = await uploadFileToFolder('comprobantes_membresia', paymentProof);

      const isSoloMensajes = viewMode === 'recargas' && hasActiveMonthlyPlan && selectedBolsa;
      const isRecargaAcceso = viewMode === 'recargas' && !hasActiveMonthlyPlan && selectedRecarga;

      let personalizedPayment;
      if (isSoloMensajes) {
        personalizedPayment = {
          tipo: 'SOLO_MENSAJES',
          description: `Bolsa Extra WhatsApp S/ ${selectedBolsa.monto} (${selectedBolsa.mensajesWhatsapp} msgs)`,
          planAmount: selectedBolsa.monto,
          amount: selectedBolsa.monto,
          mensajesWhatsapp: selectedBolsa.mensajesWhatsapp,
          paqueteId: selectedBolsa.id,
          paymentDate,
          paymentMethod,
          paymentProofUrl: paymentProofUrl,
          estado: 'PENDIENTE',
        };
      } else if (isRecargaAcceso) {
        personalizedPayment = {
          tipo: 'RECARGA',
          description: `Recarga Prepago S/ ${selectedRecarga.monto} (${selectedRecarga.diasVigencia} días + ${selectedRecarga.mensajesWhatsapp} msgs)`,
          planAmount: selectedRecarga.monto,
          amount: selectedRecarga.monto,
          diasVigencia: selectedRecarga.diasVigencia,
          mensajesWhatsapp: selectedRecarga.mensajesWhatsapp,
          paqueteId: selectedRecarga.id,
          paymentDate,
          paymentMethod,
          paymentProofUrl: paymentProofUrl,
          estado: 'PENDIENTE',
        };
      } else {
        personalizedPayment = {
          tipo: 'PLAN',
          description: 'Plan ' + (selectedPlan?.nombre || selectedPlan?.id || 'Membresía'),
          planAmount: Number(selectedPlan?.precio || 0),
          amount: Number(selectedPlan?.precio || 0),
          paymentDate,
          paymentMethod,
          paymentProofUrl: paymentProofUrl,
          estado: 'PENDIENTE',
        };
      }
      
      await registrarPagoMembresia(empresa.id, personalizedPayment);
      
      const newEmpresa = { ...empresa, estado: 'PENDIENTE' };
      dispatch(setEmpresa(newEmpresa));
      addToast("Pago registrado exitosamente. Su cuenta será activada en breve.", { appearance: "success" });
      handleCloseModal();
    } catch (error) {
      console.error("Error al registrar el pago:", error);
      addToast("Hubo un error al subir el comprobante o registrar el pago.", { appearance: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <HomeViewWrapper>
      <section className="home__section" style={{ minHeight: '80vh', padding: '40px 20px', backgroundColor: '#f8fafc' }}>
        <div className="container" style={{ background: '#f8fafc', boxShadow: 'none', maxWidth: '1200px', padding: '0px' }}>
          {loadingPlanes ? (
            <div className="text-center py-5">
              <Spinner animation="border" role="status" />
              <p className="mt-2">Cargando planes...</p>
            </div>
          ) : loadError ? (
            <div className="text-center py-5 text-danger">
              Error cargando los planes. Intente nuevamente más tarde.
            </div>
          ) : planes.length === 0 ? (
            <div className="text-center py-5 text-muted">
              No hay planes disponibles en este momento.
            </div>
          ) : (
            <div>
              {/* Selector de Modo: Planes Mensuales vs Recargas Prepago */}
              <div className="d-flex justify-content-center mb-4">
                <div
                  className="p-1 bg-white shadow-sm d-inline-flex"
                  style={{ borderRadius: '30px', border: '1.5px solid #e2e8f0' }}
                >
                  <button
                    type="button"
                    className="btn px-4 py-2 fw-bold"
                    style={{
                      borderRadius: '25px',
                      backgroundColor: viewMode === 'planes' ? '#0C234C' : 'transparent',
                      color: viewMode === 'planes' ? '#ffffff' : '#64748b',
                      border: 'none',
                      transition: 'all 0.2s',
                    }}
                    onClick={() => setViewMode('planes')}
                  >
                    {hasActiveMonthlyPlan ? '📅 Planes Mensuales' : '📅 Contratar Plan Mensual'}
                  </button>
                  <button
                    type="button"
                    className="btn px-4 py-2 fw-bold"
                    style={{
                      borderRadius: '25px',
                      backgroundColor: viewMode === 'recargas' ? (hasActiveMonthlyPlan ? '#8b5cf6' : '#0c8de3') : 'transparent',
                      color: viewMode === 'recargas' ? '#ffffff' : '#64748b',
                      border: 'none',
                      transition: 'all 0.2s',
                    }}
                    onClick={() => setViewMode('recargas')}
                  >
                    {hasActiveMonthlyPlan ? '💬 Bolsas Solo Mensajes (S/ 10, S/ 15, S/ 20)' : '⚡ Recargas Prepago (S/ 10, S/ 15, S/ 20)'}
                  </button>
                </div>
              </div>

              <Row className="g-4">
                {/* Columna Izquierda: Información de Membresía y Lista de Opciones */}
                <Col lg={5} md={12}>
                  {/* Mi Suscripción Actual */}
                  <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                    <Card.Header className="text-white fw-bold py-3" style={{ backgroundColor: '#0C234C', border: 'none' }}>
                      Mi Suscripción Actual
                    </Card.Header>
                    <Card.Body className="p-4" style={{ backgroundColor: '#ffffff' }}>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <span className="text-muted fw-bold">Modalidad / Plan:</span>
                        <span
                          className="badge px-3 py-2 fw-bold"
                          style={{
                            fontSize: '0.95rem',
                            backgroundColor: (empresa.tipoMembresia || '').toUpperCase() === 'PREPAGO' ? '#10b981' : '#0c8de3',
                            color: '#ffffff'
                          }}
                        >
                          {(empresa.tipoMembresia || '').toUpperCase() === 'PREPAGO' ? 'PREPAGO ⚡' : (empresa.tipoMembresia?.toUpperCase() || 'FREE')}
                        </span>
                      </div>

                      {empresa?.saldoMensajesWhatsapp !== undefined && (
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="text-muted fw-bold">Saldo WhatsApp:</span>
                          <span className="fw-bold text-success" style={{ fontSize: '1rem' }}>
                            💬 {empresa.saldoMensajesWhatsapp} msgs
                          </span>
                        </div>
                      )}
                      
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <span className="text-muted fw-bold">Estado:</span>
                        <span className="badge px-3 py-2 fw-bold" style={{ 
                          fontSize: '0.95rem',
                          backgroundColor: empresa.estado === 'ACTIVO' ? '#2cc789' : empresa.estado === 'PENDIENTE' ? '#ffc107' : '#dc3545',
                          color: empresa.estado === 'PENDIENTE' ? '#000000' : '#ffffff'
                        }}>
                          {empresa.estado || "ACTIVO"}
                        </span>
                      </div>

                      {empresa && empresa.fecVen && (
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="text-muted fw-bold">Vencimiento:</span>
                          <span className="fw-bold text-dark">
                            {(typeof empresa.fecVen.toDate === 'function' ? empresa.fecVen.toDate() : new Date(empresa.fecVen)).toLocaleDateString('es-ES')}
                          </span>
                        </div>
                      )}
                      
                      {empresa.estado === 'PENDIENTE' && (
                        <Alert variant="warning" className="mt-3 mb-0" style={{ borderRadius: '10px', fontSize: '0.9rem' }}>
                          Tienes un pago pendiente de validación por parte del administrador.
                        </Alert>
                      )}
                    </Card.Body>
                  </Card>

                  {/* Lista de Selección según modo */}
                  {viewMode === 'planes' ? (
                    <Card className="shadow-sm border-0" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                      <Card.Header className="text-white fw-bold py-3" style={{ backgroundColor: '#67D2DC', border: 'none' }}>
                        Planes Disponibles
                      </Card.Header>
                      <Card.Body className="p-3" style={{ backgroundColor: '#ffffff' }}>
                        {planCards.map((planItem) => {
                          const isSelected = selectedPlan && selectedPlan.id === planItem.id;
                          const isCurrent = empresa.tipoMembresia?.toLowerCase() === planItem.id?.toLowerCase();
                          return (
                            <div
                              key={planItem.id}
                              onClick={() => {
                                setSelectedPlan(planItem);
                                setPreferenceId(null);
                              }}
                              style={{
                                padding: '16px',
                                borderRadius: '12px',
                                border: isSelected ? '2px solid #0c8de3' : '1.5px solid #e2e8f0',
                                backgroundColor: isSelected ? 'rgba(12, 141, 227, 0.05)' : '#ffffff',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '12px',
                              }}
                            >
                              <div>
                                <div className="d-flex align-items-center">
                                  <span className="fw-bold text-dark" style={{ fontSize: '1.1rem' }}>
                                    {getPlanDisplayName(planItem)}
                                  </span>
                                  {isCurrent && (
                                    <span className="badge bg-success ms-2" style={{ fontSize: '0.7rem' }}>
                                      Actual
                                    </span>
                                  )}
                                </div>
                                <div className="small text-muted" style={{ fontSize: '0.8rem' }}>
                                  💬 {planItem.id?.toLowerCase() === 'basic' ? '200' : planItem.id?.toLowerCase() === 'pro' ? '400' : '700'} msgs · 👥 {planItem.id?.toLowerCase() === 'basic' ? '300 pac.' : planItem.id?.toLowerCase() === 'pro' ? '1,000 pac.' : 'Pac. ilimitados'}
                                </div>
                              </div>
                              <div className="text-end">
                                <span className="fw-bold" style={{ color: '#0c8de3', fontSize: '1.1rem' }}>
                                  S/ {getPlanPrice(planItem)}
                                </span>
                                <span className="text-muted" style={{ fontSize: '0.8rem' }}>
                                  /mes
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </Card.Body>
                    </Card>
                  ) : hasActiveMonthlyPlan ? (
                    <Card className="shadow-sm border-0" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                      <Card.Header className="text-white fw-bold py-3" style={{ backgroundColor: '#8b5cf6', border: 'none' }}>
                        💬 Bolsas de Mensajes WhatsApp Extra
                      </Card.Header>
                      <Card.Body className="p-3" style={{ backgroundColor: '#ffffff' }}>
                        <div className="alert alert-info py-2 px-3 mb-3" style={{ fontSize: '0.85rem', backgroundColor: 'rgba(139, 92, 246, 0.08)', borderColor: 'rgba(139, 92, 246, 0.2)', color: '#5b21b6', borderRadius: '8px' }}>
                          ℹ️ Como tienes un plan mensual activo (<strong>{empresa.tipoMembresia}</strong>), las recargas te otorgan la misma cantidad de mensajes (20, 35 y 50 msgs) sin alterar tu fecha de corte ni suscripción.
                        </div>
                        {BOLSAS_SOLO_MENSAJES.map((bolsaItem) => {
                          const isSelected = selectedBolsa && selectedBolsa.id === bolsaItem.id;
                          return (
                            <div
                              key={bolsaItem.id}
                              onClick={() => setSelectedBolsa(bolsaItem)}
                              style={{
                                padding: '16px',
                                borderRadius: '12px',
                                border: isSelected ? '2px solid #8b5cf6' : '1.5px solid #e2e8f0',
                                backgroundColor: isSelected ? 'rgba(139, 92, 246, 0.06)' : '#ffffff',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                marginBottom: '12px',
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span className="fw-bold text-dark" style={{ fontSize: '1.05rem' }}>
                                  {bolsaItem.nombre}
                                </span>
                                <span className="fw-bold" style={{ color: '#5b21b6', fontSize: '1.15rem' }}>
                                  S/ {bolsaItem.monto.toFixed(2)}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between align-items-center">
                                <span className="small text-muted">
                                  💬 {bolsaItem.mensajesWhatsapp} mensajes (~S/ {(bolsaItem.monto / bolsaItem.mensajesWhatsapp).toFixed(2)} c/u)
                                </span>
                                {bolsaItem.badge && (
                                  <span
                                    className="badge"
                                    style={{ backgroundColor: bolsaItem.badgeBg, fontSize: '0.7rem' }}
                                  >
                                    {bolsaItem.badge}
                                  </span>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </Card.Body>
                    </Card>
                  ) : (
                    <Card className="shadow-sm border-0" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                      <Card.Header className="text-white fw-bold py-3" style={{ backgroundColor: '#0c8de3', border: 'none' }}>
                        ⚡ Paquetes de Recarga Prepago
                      </Card.Header>
                      <Card.Body className="p-3" style={{ backgroundColor: '#ffffff' }}>
                        <div className="alert alert-secondary py-2 px-3 mb-3" style={{ fontSize: '0.85rem', borderRadius: '8px' }}>
                          ⚡ <strong>Modalidad Recarga:</strong> Acceso al software por días + mensajes WhatsApp (Tope: 1 usuario y hasta 50 pacientes). Una vez superada esta cantidad de pacientes, <strong>deberás pasar a la modalidad por planes</strong>.
                        </div>
                        {PAQUETES_RECARGA.map((recargaItem) => {
                          const isSelected = selectedRecarga && selectedRecarga.id === recargaItem.id;
                          return (
                            <div
                              key={recargaItem.id}
                              onClick={() => setSelectedRecarga(recargaItem)}
                              style={{
                                padding: '16px',
                                borderRadius: '12px',
                                border: isSelected ? '2px solid #0c8de3' : '1.5px solid #e2e8f0',
                                backgroundColor: isSelected ? 'rgba(12, 141, 227, 0.06)' : '#ffffff',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                marginBottom: '12px',
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span className="fw-bold text-dark" style={{ fontSize: '1.05rem' }}>
                                  {recargaItem.nombre}
                                </span>
                                <span className="fw-bold" style={{ color: '#0C234C', fontSize: '1.15rem' }}>
                                  S/ {recargaItem.monto.toFixed(2)}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between align-items-center">
                                <span className="small text-muted">
                                  🗓️ +{recargaItem.diasVigencia} días · 💬 {recargaItem.mensajesWhatsapp} msgs · 👥 Máx 50 pac.
                                </span>
                                {recargaItem.badge && (
                                  <span
                                    className="badge"
                                    style={{ backgroundColor: recargaItem.badgeBg, fontSize: '0.7rem' }}
                                  >
                                    {recargaItem.badge}
                                  </span>
                                )}
                              </div>
                            </div>
                          );
                        })}

                        {/* Banner de Incentivo a Plan Mensual */}
                        <div className="p-3 mt-3 text-start shadow-sm" style={{ borderRadius: '12px', background: 'linear-gradient(135deg, #0C234C 0%, #1e3a8a 100%)', color: '#ffffff' }}>
                          <div className="fw-bold mb-1" style={{ fontSize: '0.95rem', color: '#67D2DC' }}>
                            🚀 ¿Superaste los 50 pacientes o necesitas más equipo?
                          </div>
                          <div style={{ fontSize: '0.85rem', color: '#e2e8f0', lineHeight: '1.4' }}>
                            Pasa a la <strong>modalidad por planes</strong>: con el <strong>Plan Basic (S/ 80/mes)</strong> obtienes <strong>200 mensajes</strong>, hasta <strong>300 pacientes</strong> y acceso para <strong>2 usuarios</strong> (Doctor + Recepcionista).
                          </div>
                          <button
                            type="button"
                            className="btn btn-sm mt-2 fw-bold w-100"
                            style={{ backgroundColor: '#67D2DC', color: '#0C234C', borderRadius: '8px' }}
                            onClick={() => setViewMode('planes')}
                          >
                            Ver Planes Mensuales →
                          </button>
                        </div>
                      </Card.Body>
                    </Card>
                  )}
                </Col>

              {/* Columna Derecha: Detalle del Plan / Recarga y Proceso de Pago */}
              <Col lg={7} md={12}>
                {viewMode === 'recargas' ? (
                  hasActiveMonthlyPlan ? (
                    <div className="d-flex justify-content-center w-100">
                      <div
                        className="plan-card"
                        style={{
                          borderRadius: '16px',
                          padding: '36px 30px',
                          backgroundColor: '#ffffff',
                          border: selectedBolsa?.popular ? '2.5px solid #8b5cf6' : '1.5px solid rgba(139, 92, 246, 0.35)',
                          boxShadow: '0 10px 25px -5px rgba(139, 92, 246, 0.15)',
                          background: selectedBolsa?.popular ? 'linear-gradient(180deg, #f5f3ff 0%, #ffffff 100%)' : '#ffffff',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          position: 'relative',
                          height: '100%',
                          width: '100%',
                          maxWidth: '440px',
                          boxSizing: 'border-box'
                        }}
                      >
                        {selectedBolsa?.badge && (
                          <span
                            className="position-absolute top-0 start-50 translate-middle badge rounded-pill px-3 py-2 text-white fw-bold shadow-sm"
                            style={{ backgroundColor: selectedBolsa.badgeBg, fontSize: '0.85rem' }}
                          >
                            {selectedBolsa.badge}
                          </span>
                        )}

                        <div className="w-100 d-flex flex-column align-items-center mb-4">
                          <span className="fw-bold text-dark mb-1" style={{ fontSize: '1.8rem', letterSpacing: '0.5px' }}>
                            {selectedBolsa?.nombre}
                          </span>

                          <div className="plan-card__price d-flex align-items-baseline justify-content-center mt-2 mb-2 w-100" style={{ color: '#5b21b6' }}>
                            <span className="fw-bold me-1" style={{ fontSize: '1.8rem', alignSelf: 'flex-start', marginTop: '4px' }}>S/</span>
                            <span className="fw-bold" style={{ fontSize: '3.8rem', lineHeight: '1' }}>{selectedBolsa?.monto}</span>
                            <span className="text-muted ms-1" style={{ fontSize: '0.9rem', fontWeight: 'normal' }}>/bolsa</span>
                          </div>

                          <p className="text-center mb-3 px-2 text-muted" style={{ fontSize: '0.95rem' }}>
                            {selectedBolsa?.descripcion}
                          </p>

                          <div className="w-100 mt-2" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <div className="d-flex align-items-start text-start w-100" style={{ fontSize: '0.95rem', color: '#2d3a4b' }}>
                              <span className="me-2 fw-bold" style={{ color: '#8b5cf6' }}>💬</span>
                              <span><strong>+{selectedBolsa?.mensajesWhatsapp} mensajes WhatsApp</strong> (~S/ {(selectedBolsa?.monto / (selectedBolsa?.mensajesWhatsapp || 1)).toFixed(2)} c/u)</span>
                            </div>
                            <div className="d-flex align-items-start text-start w-100" style={{ fontSize: '0.95rem', color: '#2d3a4b' }}>
                              <span className="me-2 fw-bold text-success">📅</span>
                              <span><strong>Sin alterar tu plan:</strong> Conservas tu fecha de vencimiento y suscripción ({empresa.tipoMembresia})</span>
                            </div>
                            <div className="d-flex align-items-start text-start w-100" style={{ fontSize: '0.95rem', color: '#2d3a4b' }}>
                              <span className="me-2 fw-bold text-info">⚡</span>
                              <span><strong>Misma escala de mensajes:</strong> S/ 10 (20 msgs), S/ 15 (35 msgs) y S/ 20 (50 msgs)</span>
                            </div>
                            <div className="d-flex align-items-start text-start w-100" style={{ fontSize: '0.95rem', color: '#2d3a4b' }}>
                              <span className="me-2 fw-bold text-warning">🔄</span>
                              <span><strong>No expiran:</strong> Los mensajes acumulados permanecen mientras tu cuenta esté activa</span>
                            </div>
                          </div>
                        </div>

                        <div className="plan-card__button-container mt-auto w-100 d-flex flex-column gap-2">
                          <Button
                            className="w-100 py-3 fw-bold"
                            style={{
                              borderRadius: '10px',
                              fontSize: '1.05rem',
                              backgroundColor: '#8b5cf6',
                              borderColor: '#8b5cf6',
                              color: '#ffffff',
                              transition: 'all 0.2s ease',
                            }}
                            disabled={empresa.estado === 'PENDIENTE'}
                            onClick={handlePayClick}
                          >
                            Comprar Bolsa S/ {selectedBolsa?.monto} con Yape / Plin
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-center w-100">
                      <div
                        className="plan-card"
                        style={{
                          borderRadius: '16px',
                          padding: '36px 30px',
                          backgroundColor: '#ffffff',
                          border: selectedRecarga?.popular ? '2.5px solid #0c8de3' : '1.5px solid rgba(12, 141, 227, 0.35)',
                          boxShadow: '0 10px 25px -5px rgba(12, 141, 227, 0.15)',
                          background: selectedRecarga?.popular ? 'linear-gradient(180deg, #edf5fe 0%, #ffffff 100%)' : '#ffffff',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          position: 'relative',
                          height: '100%',
                          width: '100%',
                          maxWidth: '440px',
                          boxSizing: 'border-box'
                        }}
                      >
                        {selectedRecarga?.badge && (
                          <span
                            className="position-absolute top-0 start-50 translate-middle badge rounded-pill px-3 py-2 text-white fw-bold shadow-sm"
                            style={{ backgroundColor: selectedRecarga.badgeBg, fontSize: '0.85rem' }}
                          >
                            {selectedRecarga.badge}
                          </span>
                        )}

                        <div className="w-100 d-flex flex-column align-items-center mb-4">
                          <span className="fw-bold text-dark mb-1" style={{ fontSize: '1.8rem', letterSpacing: '0.5px' }}>
                            {selectedRecarga?.nombre}
                          </span>

                          <div className="plan-card__price d-flex align-items-baseline justify-content-center mt-2 mb-2 w-100" style={{ color: '#0C234C' }}>
                            <span className="fw-bold me-1" style={{ fontSize: '1.8rem', alignSelf: 'flex-start', marginTop: '4px' }}>S/</span>
                            <span className="fw-bold" style={{ fontSize: '3.8rem', lineHeight: '1' }}>{selectedRecarga?.monto}</span>
                            <span className="text-muted ms-1" style={{ fontSize: '0.9rem', fontWeight: 'normal' }}>/recarga</span>
                          </div>

                          <p className="text-center mb-3 px-2 text-muted" style={{ fontSize: '0.95rem' }}>
                            {selectedRecarga?.descripcion}
                          </p>

                          <div className="w-100 mt-2" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <div className="d-flex align-items-start text-start w-100" style={{ fontSize: '0.95rem', color: '#2d3a4b' }}>
                              <span className="me-2 fw-bold text-primary">🗓️</span>
                              <span><strong>+{selectedRecarga?.diasVigencia} días</strong> de vigencia total del software dental</span>
                            </div>
                            <div className="d-flex align-items-start text-start w-100" style={{ fontSize: '0.95rem', color: '#2d3a4b' }}>
                              <span className="me-2 fw-bold text-success">💬</span>
                              <span><strong>+{selectedRecarga?.mensajesWhatsapp} mensajes WhatsApp</strong> incluidos (~S/ {(selectedRecarga?.monto / (selectedRecarga?.mensajesWhatsapp || 1)).toFixed(2)} c/u)</span>
                            </div>
                            <div className="d-flex align-items-start text-start w-100" style={{ fontSize: '0.95rem', color: '#2d3a4b' }}>
                              <span className="me-2 fw-bold text-info">⚡</span>
                              <span><strong>Acumulable:</strong> Suma a tu fecha actual si recargas anticipadamente</span>
                            </div>
                            <div className="d-flex align-items-start text-start w-100" style={{ fontSize: '0.95rem', color: '#2d3a4b' }}>
                              <span className="me-2 fw-bold text-warning">🔄</span>
                              <span><strong>Rollover:</strong> Mensajes no usados se acumulan para tu próxima recarga</span>
                            </div>
                            <div className="d-flex align-items-start text-start w-100" style={{ fontSize: '0.95rem', color: '#2d3a4b' }}>
                              <span className="me-2 fw-bold text-secondary">🦷</span>
                              <span>Acceso a Agenda, Odontograma, Pacientes, Presupuestos y Caja</span>
                            </div>
                            <div className="d-flex align-items-start text-start w-100 p-2 mt-1" style={{ fontSize: '0.85rem', backgroundColor: '#fff8e1', border: '1px solid #ffe082', borderRadius: '8px', color: '#b78103' }}>
                              <span className="me-2 fw-bold">⚠️</span>
                              <span><strong>Límite de la modalidad Recargas:</strong> Máximo 1 usuario titular y hasta 50 pacientes registrados. Una vez superada esta cantidad de pacientes, <strong>deberás pasar a la modalidad por planes</strong>.</span>
                            </div>
                          </div>
                        </div>

                        <div className="plan-card__button-container mt-auto w-100 d-flex flex-column gap-2">
                          <Button
                            className="w-100 py-3 fw-bold"
                            style={{
                              borderRadius: '10px',
                              fontSize: '1.05rem',
                              backgroundColor: '#0c8de3',
                              borderColor: '#0c8de3',
                              color: '#ffffff',
                              transition: 'all 0.2s ease',
                            }}
                            disabled={empresa.estado === 'PENDIENTE'}
                            onClick={handlePayClick}
                          >
                            Pagar Recarga S/ {selectedRecarga?.monto} con Yape / Plin
                          </Button>
                        </div>
                      </div>
                    </div>
                  )
                ) : selectedPlan ? (
                  preferenceId ? (
                    <section className="payment-form dark w-100 p-0" style={{ borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                      <div className="form-payment w-100 m-0" style={{ borderTop: 'none' }}>
                        <div className="products p-4" style={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
                          <h2 className="title fw-bold" style={{ color: '#0C234C', borderBottomColor: '#0c8de3' }}>Resumen del Pago</h2>
                          <div className="item d-flex justify-content-between align-items-center my-3">
                            <span className="item-name fw-bold" style={{ fontSize: '1.1rem' }}>
                              {getCheckoutPlanName(selectedPlan)}
                            </span>
                            <span className="price fw-bold" id="summary-price" style={{ color: '#0c8de3', fontSize: '1.2rem' }}>
                              S/ {getPlanPrice(selectedPlan)}
                            </span>
                          </div>
                          <div className="total d-flex justify-content-between align-items-center pt-3 mt-3" style={{ borderTop: '2px solid #0c8de3' }}>
                            <span className="fw-bold h5 mb-0">Total</span>
                            <span className="price fw-bold h4 mb-0" id="summary-total" style={{ color: '#0c8de3' }}>
                              S/ {getPlanPrice(selectedPlan)}
                            </span>
                          </div>
                        </div>
                        <div className="payment-details p-4" style={{ backgroundColor: '#ffffff', borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }}>
                          <div className="form-group col-sm-12 text-center">
                            <div id="button-checkout" className="w-100 mb-3"></div>
                            <Button
                              variant="link"
                              className="text-decoration-none fw-bold"
                              style={{ color: '#dc3545' }}
                              onClick={() => setPreferenceId(null)}
                            >
                              Volver y cambiar plan
                            </Button>
                          </div>
                        </div>
                      </div>
                    </section>
                  ) : (
                    <div className="d-flex justify-content-center w-100">
                      <div
                        className="plan-card"
                        onMouseEnter={() => setHoveredCardId(selectedPlan.id)}
                        onMouseLeave={() => setHoveredCardId(null)}
                        style={{
                          borderRadius: '16px',
                          padding: '36px 30px',
                          backgroundColor: '#ffffff',
                          border: selectedPlan.id?.toLowerCase() === 'pro' ? '2.5px solid #0c8de3' : '1.5px solid rgba(12, 141, 227, 0.35)',
                          boxShadow: hoveredCardId === selectedPlan.id
                            ? (selectedPlan.id?.toLowerCase() === 'pro' 
                                ? '0 20px 35px -5px rgba(12, 141, 227, 0.25), 0 12px 16px -6px rgba(12, 141, 227, 0.25)' 
                                : '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)')
                            : (selectedPlan.id?.toLowerCase() === 'pro' 
                                ? '0 10px 25px -5px rgba(12, 141, 227, 0.15), 0 8px 10px -6px rgba(12, 141, 227, 0.15)' 
                                : '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05)'),
                          transform: hoveredCardId === selectedPlan.id ? 'translateY(-6px)' : 'none',
                          background: selectedPlan.id?.toLowerCase() === 'pro' ? 'linear-gradient(180deg, #edf5fe 0%, #ffffff 100%)' : '#ffffff',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          position: 'relative',
                          height: '100%',
                          width: '100%',
                          maxWidth: '420px',
                          transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                          boxSizing: 'border-box'
                        }}
                      >
                        <div className="w-100 d-flex flex-column align-items-center mb-4">
                          <span className="fw-bold text-dark mb-1" style={{ fontSize: '1.8rem', letterSpacing: '0.5px' }}>
                            {getPlanDisplayName(selectedPlan)}
                          </span>
                          
                          {selectedPlan.id?.toLowerCase() === 'pro' && (
                            <span className="badge rounded-pill px-3 py-1 mb-3" style={{ fontSize: '0.75rem', backgroundColor: '#0c8de3', color: '#ffffff', fontWeight: 'bold' }}>
                              Más popular
                            </span>
                          )}

                          <div className="plan-card__price d-flex align-items-baseline justify-content-center mt-2 mb-2 w-100" style={{ color: '#0c8de3' }}>
                            <span className="fw-bold me-1" style={{ fontSize: '1.8rem', color: '#0c8de3', alignSelf: 'flex-start', marginTop: '4px' }}>S/</span>
                            <span className="fw-bold" style={{ fontSize: '3.8rem', lineHeight: '1', color: '#0c8de3' }}>{getPlanPrice(selectedPlan)}</span>
                            <span className="text-muted ms-1" style={{ fontSize: '1rem', fontWeight: 'normal' }}>/mes</span>
                          </div>

                          <p className="text-center mb-4 px-2" style={{ color: '#0c8de3', fontSize: '0.95rem', fontWeight: '500', minHeight: '40px' }}>
                            {selectedPlan.descripcion || "Para empezar con orden"}
                          </p>

                          <div className="w-100 mt-2" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {getFeaturesForPlan(selectedPlan).map((feat, idx) => (
                              <div key={idx} className="d-flex align-items-start text-start w-100" style={{ fontSize: '0.95rem', color: '#2d3a4b', lineHeight: '1.4' }}>
                                <span className="me-2 fw-bold" style={{ color: '#0c8de3' }}>✓</span>
                                <span>{feat}</span>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="plan-card__button-container mt-auto w-100 d-flex flex-column gap-2">
                          <Button
                            className="w-100 py-2.5"
                            style={{
                              borderRadius: '10px',
                              fontWeight: '700',
                              fontSize: '1rem',
                              backgroundColor: '#0C234C',
                              borderColor: '#0C234C',
                              color: '#ffffff',
                              transition: 'all 0.2s ease',
                              borderWidth: '0px'
                            }}
                            disabled={empresa.estado === 'PENDIENTE'}
                            onClick={handlePayClick}
                            onMouseOver={(e) => {
                              if (empresa.estado !== 'PENDIENTE') {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(12, 35, 76, 0.3)';
                              }
                            }}
                            onMouseOut={(e) => {
                              if (empresa.estado !== 'PENDIENTE') {
                                e.currentTarget.style.transform = 'none';
                                e.currentTarget.style.boxShadow = 'none';
                              }
                            }}
                          >
                            Registrar Pago Manual
                          </Button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className="text-center py-5 text-muted">
                    Selecciona un plan para ver los detalles.
                  </div>
                )}
              </Col>
            </Row>
          </div>
          )}
        </div>
      </section>

      {/* Modal de Pago Manual */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {viewMode === 'recargas'
              ? (hasActiveMonthlyPlan ? 'Comprar Bolsa de WhatsApp Extra' : 'Registrar Recarga Prepago (Acceso + Mensajes)')
              : 'Registrar Pago de Suscripción'}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmitPayment}>
          <Modal.Body>
            {viewMode === 'recargas' && (
              hasActiveMonthlyPlan && selectedBolsa ? (
                <Alert variant="primary" className="mb-3 py-2 px-3" style={{ fontSize: '0.9rem', borderRadius: '10px', backgroundColor: 'rgba(139, 92, 246, 0.1)', borderColor: '#8b5cf6', color: '#5b21b6' }}>
                  💬 <strong>{selectedBolsa.nombre}:</strong> S/ {selectedBolsa.monto} · +{selectedBolsa.mensajesWhatsapp} mensajes WhatsApp · No altera fecha de suscripción
                </Alert>
              ) : selectedRecarga ? (
                <Alert variant="info" className="mb-3 py-2 px-3" style={{ fontSize: '0.9rem', borderRadius: '10px' }}>
                  ⚡ <strong>{selectedRecarga.nombre}:</strong> S/ {selectedRecarga.monto} · +{selectedRecarga.diasVigencia} días de acceso · +{selectedRecarga.mensajesWhatsapp} mensajes WhatsApp · Tope 50 pacientes
                </Alert>
              ) : null
            )}
            <Form.Group className="mb-3" controlId="formMonto">
              <Form.Label>Monto a Pagar</Form.Label>
              <Form.Control
                type="text"
                value={`S/ ${(viewMode === 'recargas' ? (hasActiveMonthlyPlan ? selectedBolsa?.monto : selectedRecarga?.monto) : selectedPlan?.precio)?.toFixed(2) || '0.00'}`}
                readOnly
                disabled
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formFecha">
              <Form.Label>Fecha de Pago</Form.Label>
              <Form.Control
                type="date"
                value={paymentDate}
                onChange={(e) => setPaymentDate(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formMedioPago">
              <Form.Label>Medio de Pago</Form.Label>
              <Form.Select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} required>
                <option value="Yape">Yape</option>
                <option value="Plin">Plin</option>
                <option value="Transferencia Bancaria">Transferencia Bancaria</option>
              </Form.Select>
            </Form.Group>
            {((paymentMethod === 'Yape' && yapeUrlFile) || (paymentMethod === 'Plin' && plinUrlFile)) && (
              <div className="my-4 p-3 border rounded text-center bg-light" style={{ borderRadius: '12px' }}>
                <span className="fw-bold d-block mb-2" style={{ color: '#0C234C', fontSize: '0.95rem' }}>
                  1. Escanea el código QR de {paymentMethod} para realizar el pago:
                </span>
                <div 
                  style={{ 
                    position: 'relative', 
                    display: 'inline-block', 
                    cursor: 'zoom-in',
                    backgroundColor: '#fff',
                    padding: '8px',
                    borderRadius: '8px',
                    border: '1px solid #dee2e6'
                  }} 
                  onClick={() => setShowQrZoom(true)}
                  title="Haz clic para ampliar"
                >
                  <img 
                    src={paymentMethod === 'Yape' ? yapeUrlFile : plinUrlFile} 
                    alt={`${paymentMethod} QR`} 
                    className="img-fluid rounded shadow-sm" 
                    style={{ 
                      maxHeight: '260px', 
                      objectFit: 'contain',
                      transition: 'all 0.2s ease-in-out'
                    }} 
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.03)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                    }}
                  />
                  <div className="text-muted mt-2 fw-medium" style={{ fontSize: '0.8rem' }}>
                    🔍 Haz clic para ampliar
                  </div>
                </div>
              </div>
            )}
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label className="fw-bold">
                {((paymentMethod === 'Yape' && yapeUrlFile) || (paymentMethod === 'Plin' && plinUrlFile)) 
                  ? "2. Sube el voucher generado (Imagen o PDF)" 
                  : "Sube el comprobante de pago (Imagen o PDF)"}
              </Form.Label>
              <Form.Control type="file" accept="image/*,.pdf" onChange={handleFileChange} required />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal} disabled={isSubmitting}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit" disabled={isSubmitting} style={{ backgroundColor: '#0c8de3', borderColor: '#0c8de3' }}>
              {isSubmitting ? (
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
              ) : (
                "Registrar Pago"
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Modal de Zoom QR */}
      <Modal show={showQrZoom} onHide={() => setShowQrZoom(false)} centered size="md" style={{ zIndex: 1060 }}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1.1rem', color: '#0C234C', fontWeight: 'bold' }}>
            Código QR de {paymentMethod}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-4 bg-light">
          <img
            src={paymentMethod === 'Yape' ? yapeUrlFile : plinUrlFile}
            alt={`${paymentMethod} QR Ampliado`}
            className="img-fluid rounded shadow-sm bg-white p-2 border"
            style={{ maxHeight: '70vh', maxWidth: '100%', objectFit: 'contain' }}
          />
          <div className="mt-3 text-muted" style={{ fontSize: '0.9rem' }}>
            Escanea este código QR con la app de tu banco/billetera digital para realizar el pago.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowQrZoom(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </HomeViewWrapper>
  );
};
